export const PLANNING_URL = 'planning';
